import { Component, Input, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import rolemap from '../../../rolemap.json';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-landing-card',
  templateUrl: './landing-card.component.html',
  styleUrls: ['./landing-card.component.scss'],
})
export class LandingCardComponent implements OnInit {
  showEngines: boolean = false;
  showParts: boolean = false;
  showSalesParts: boolean = false;
  showCssna: boolean = false;
  showInter: boolean = false;
  powerEngines: boolean = false;
  powerGen: boolean = false;
  showCssnaEngine: boolean = false;
  showInternationalEngine: boolean = false;
  industrial: boolean = false;
  onHighway: boolean = false;
  activeItem: any;
  expandItem: any;
  isEnabled: boolean = false;
  userRole;
  enabledRoutes: any;
  showOmni: boolean = false;
  segmentationUrl = environment.psbuSegmentationUrl;
  constructor(private keycloakService: KeycloakService) {}

  ngOnInit(): void {
  //   this.userRole = this.keycloakService.getUserRoles();
  //   let roles: any[] = [];
  //   this.enabledRoutes = [];
  //   rolemap?.forEach((item: any, index: any) => {
  //     Object.entries(item).forEach((res: any, key: any) => {
  //       roles.push(res[0]);
  //       roles.forEach((element) => {
  //         if (this.userRole?.indexOf(element) > -1) {
  //           this.enabledRoutes = rolemap[0][element];
  //         } else {
  //         }
  //       });
  //     });
  //   });
  // }
  this.userRole = this.keycloakService.getUserRoles();
this.enabledRoutes = [];

let omniAccess = false;

rolemap?.forEach((item: any) => {
  Object.entries(item).forEach(([roleKey, paths]) => {
    // If user's role includes the roleKey
    if (this.userRole.includes(roleKey)) {
      if (Array.isArray(paths)) {
        this.enabledRoutes.push(...paths);
      }
    }

    // Check for "omni" in roleKey
    if (roleKey.toLowerCase().includes('omni')) {
      if (this.userRole.includes(roleKey)) {
        omniAccess = true;
      }
    }
  });
});

// Allow access to /omni/dashboard if any user role contains "omni"
if (omniAccess) {
  this.enabledRoutes.push('/omni/dashboard');
}
  }
  expandEngines() {
    this.showEngines = true;
    this.showParts = false;
    this.showCssna = false;
    this.showInter = false;
  }
  expandParts() {
    this.showParts = true;
    this.showEngines = false;
    this.showCssna = false;
    this.showInter = false;
  }

  expandPowerEngines() {
    this.powerEngines = true;
    this.powerGen = false;
  }

  //CSSNA start

  expandCssna() {
    this.showCssna = true;
    this.showInter = false;
  }
  expandPowerGen() {
    this.powerEngines = false;
    this.powerGen = true;
    this.industrial = false;
    this.onHighway = false;
  }
  expandIndustrial() {
    this.powerEngines = false;
    this.powerGen = false;
    this.industrial = true;
    this.onHighway = false;
  }
  expandonHighway() {
    this.powerEngines = false;
    this.powerGen = false;
    this.industrial = false;
    this.onHighway = true;
  }
  //end of CSSNA

  //International start
  expandInter() {
    this.showCssna = false;
    this.showInter = true;
  }
  setActiveItem(item) {
    this.activeItem = item;
  }
  setExpandItem(item) {
    this.expandItem = item;
  }
  //International end
  enabledRouteContains(event) {
    if (this.enabledRoutes.length == 0) {
      return true;
    } else {
      if (this.enabledRoutes?.indexOf(event) > -1) {
        return true;
      } else {
        return false;
      }
    }
  }

  goToSegmentationDashboard(): void {
    if (this.segmentationUrl) {
      window.open(this.segmentationUrl, '_blank');
    }
  }

}
